export default "__VITE_ASSET__bf2e2918__"